<template>
  <div>
    <MenuHeader :record_id="record_id" type="menus">
      <div class="row">
        <div class="col-12">
          <b-card>
            <form id="container__form" @submit.prevent="save">
              <tooltip label="menu name" placement="right">
                <input
                  name="menu_name"
                  v-model="record.ds_name"
                  v-validate="'required'"
                  :class="{'form-control': true, 'is-invalid': errors.has('menu_name')}"
                  type="text"
                  :placeholder="$t('menu name')"
                />
                <span
                  v-show="errors.has('menu_name')"
                  class="help invalid-feedback"
                >{{ $t(errors.first('menu_name')) }}</span>
              </tooltip>
              <tooltip label="related to services" label-for="services_list">
                <b-form-group :horizontal="false">
                  <b-form-select
                    id="services_list"
                    :plain="true"
                    :multiple="true"
                    :options="servicesOptions"
                    v-model="record.ds_services"
                  ></b-form-select>
                </b-form-group>
              </tooltip>
              <tooltip label="menu tax" placement="right">
                <input
                  name="menu_tax"
                  v-model="record.ds_tax"
                  v-validate="''"
                  :class="{'form-control': true, 'is-invalid': errors.has('menu_tax')}"
                  type="text"
                  placeholder="2.5%"
                />
                <span
                  v-show="errors.has('menu_tax')"
                  class="help invalid-feedback"
                >{{ $t(errors.first('menu_tax')) }}</span>
              </tooltip>
              <tooltip label="menu shipping" placement="right">
                <input
                  name="menu_shipping"
                  v-model="record.ds_shipping"
                  v-validate="''"
                  :class="{'form-control': true, 'is-invalid': errors.has('menu_shipping')}"
                  type="text"
                  placeholder="1%"
                />
                <span
                  v-show="errors.has('menu_shipping')"
                  class="help invalid-feedback"
                >{{ $t(errors.first('menu_shipping')) }}</span>
              </tooltip>
            </form>
            <hr />

            <field-structures :schema="record.ds_schema" @change="handleOnChangeSchema"></field-structures>

            <hr />

            <!-- Start Response Actions Card  -->
            <response-action
              headTitle="complete order"
              fieldPrefix="ds_action"
              :dataSet="record"
              :includeSenderInfo="false"
              @change="handleOnChangeResponseAction"
            ></response-action>
            <!-- End Response Actions Card -->
          </b-card>
        </div>
        <ButtonSubmit />
      </div>
    </MenuHeader>
  </div>
</template>
<script>
import axios from 'axios'
import fieldStructures from '../../components/fieldStructures'
import {ButtonSubmit, MenuHeader} from '../../components'
import ResponseAction from '../../components/ResponseAction'

export default {
	name: 'datasetForm',
	components: {
		ButtonSubmit,
		MenuHeader,
		ResponseAction,
		fieldStructures,
	},
	data() {
		return {
			record_id: 0,
			record: {
				ds_name: '',
				ds_tax: 0,
				ds_shipping: 0,
				ds_schema: [
					{
						name: 'title',
						type: 'text',
						permission: 'r',
                    },
					{
						name: 'tags',
						type: 'list',
						permission: 'r',
					},
					{
						name: 'subtitle',
						type: 'text',
						permission: 'r',
					},
					{
						name: 'price',
						type: 'number',
						permission: 'r',
					},
					{
						name: 'image',
						type: 'text',
						permission: 'r',
					},
				],
				ds_services: [],
			},
			constantFields: ['title', 'subtitle', 'price', 'image', 'tags'],
			servicesOptions: [],
		}
	},
	methods: {
		handleOnChangeSchema(schema) {
			this.record.ds_schema = schema
		},

		handleOnChangeResponseAction(data) {
			this.record = {
				...this.record,
				...data,
			}
		},
		save(e) {
			const data = {
				...this.record,
				ds_type: 'menu',
			}

			data.ds_schema = data.ds_schema.reduce((el1, el2) => {
				return el1.concat({
					...el2,
					permission: (() => {
						return this.constantFields.indexOf(el2.name) === -1 ? 'rw' : 'r'
					})(),
				})
			}, [])

			e.preventDefault()
			this.$validator.validateAll(['menu_name']).then((success) => {
				if (success) {
					this.$root.loader = true
					axios
						.post('/dataset/save/' + this.record_id, data)
						.then((response) => {
							this.$root.loader = false
							if (response.data.status == 1) {
								this.$store.commit('update_breadcrumb_history', {
									mode: 'menus',
									id: this.record_id,
									change_to: this.record.ds_name,
								})

								this.$router.push('/menus/' + response.data.id)

								this.record_id &&
									this.$root.notify({
										message: this.$t('successfully updated'),
										status: 'success',
										area: 'topRight',
									})
							}
						})
						.catch(() => {
							this.$root.loader = false
						})
				}
			})
		},
	},
	mounted() {
		if (parseInt(this.$route.params.id) >= 1) {
			this.record_id = parseInt(this.$route.params.id)
			this.$root.loader = true
			axios
				.get('/dataset/browse/' + this.record_id)
				.then((response) => {
					this.$root.loader = false
					if (response.data.status == 1) {
						this.record = {
							...this.record,
							...response.data.data,
						}
					}
				})
				.catch(() => {
					this.$root.loader = false
				})
		} else {
			this.record_id = 0
			this.$root.loader = false
		}
		if (this.$store.state.go_services.length) {
			var recursiveServices = function(services, edited_services = []) {
				if (!services.length) return edited_services
				var service_one = services.splice(0, 1)[0]
				edited_services = [].concat(edited_services, {
					text: service_one.service_name,
					value: service_one.service_id,
					disabled: !service_one.service_status,
				})
				return recursiveServices(services, edited_services)
			}
			this.servicesOptions = recursiveServices(this.$store.state.go_services.slice())
		}
	},
}
</script>
